import { resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../assets/me.png'


const _withScopeId = n => (_pushScopeId("data-v-36702ee5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "business_card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://cataas.com/#/",
  target: "_bank"
}, "CataaS", -1))
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "p-grid" }
const _hoisted_5 = {
  class: "p-col-fixed",
  style: {"width":"200px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "180",
  id: "image_me",
  alt: "Mario Streubel",
  src: _imports_0
}, null, -1))
const _hoisted_7 = { class: "p-d-flex p-jc-between p-mt-3" }
const _hoisted_8 = { class: "social_button" }
const _hoisted_9 = {
  href: "https://buymeacoffee.com/MarioStreubel",
  target: "_blank"
}
const _hoisted_10 = { class: "social_button" }
const _hoisted_11 = {
  href: "https://www.paypal.com/paypalme/MarioStreubel",
  target: "_blank"
}
const _hoisted_12 = { class: "p-d-flex p-jc-between p-mt-5" }
const _hoisted_13 = { class: "social_button" }
const _hoisted_14 = {
  href: "https://www.xing.com/profile/Mario_Streubel",
  target: "_blank"
}
const _hoisted_15 = { class: "social_button" }
const _hoisted_16 = {
  href: "https://de.linkedin.com/in/mario-streubel-a04344a8/en",
  target: "_blank"
}
const _hoisted_17 = { class: "social_button" }
const _hoisted_18 = { href: "mailto:mail@streubel-mario.de" }
const _hoisted_19 = { class: "p-d-flex p-jc-between p-mt-5" }
const _hoisted_20 = { class: "social_button" }
const _hoisted_21 = {
  href: "https://kana-trainer.streubel-mario.de",
  target: "_blank"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main_text p-col p-m-3" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Welcome, "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("my name is Mario Streubel.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "I am an IT professional specialising in software development."),
  /*#__PURE__*/_createElementVNode("p", null, "My favorite animals are bears, meerkats, cats and honeybadgers."),
  /*#__PURE__*/_createElementVNode("p", null, "I like playing video games and converting coffee into code."),
  /*#__PURE__*/_createElementVNode("p", null, "If you want to learn more about me and my professional skills, visit me on LinkedIn or Xing."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "Yours faithfuly, Mario")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dialog, {
      header: "Cat",
      visible: _ctx.displayDialog,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.displayDialog) = $event)),
      onHide: this.loadCat
    }, {
      default: _withCtx(() => [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _createVNode(_component_Image, { src: _ctx.catImage }, null, 8, ["src"])
          ]),
          _: 1
        }),
        _createElementVNode("p", null, [
          _createTextVNode("Source: "),
          _hoisted_2,
          _createTextVNode(" | "),
          _createElementVNode("a", {
            href: _ctx.catImage,
            target: "_blank"
          }, "Link", 8, _hoisted_3)
        ])
      ]),
      _: 1
    }, 8, ["visible", "onHide"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "social_button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.releaseTheCat && _ctx.releaseTheCat(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'cat'] })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", _hoisted_9, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'mug-hot'] })
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", _hoisted_11, [
              _createVNode(_component_font_awesome_icon, { icon: ['fab', 'paypal'] })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", _hoisted_14, [
              _createVNode(_component_font_awesome_icon, { icon: ['fab', 'xing-square'] })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("a", _hoisted_16, [
              _createVNode(_component_font_awesome_icon, { icon: ['fab', 'linkedin'] })
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("a", _hoisted_18, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'at'] })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("a", _hoisted_21, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'language'] })
            ])
          ])
        ])
      ]),
      _hoisted_22
    ])
  ]))
}